import script from "./SharedPopupApp.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedPopupApp.vue?vue&type=script&setup=true&lang=js"

import "./SharedPopupApp.vue?vue&type=style&index=0&id=208ba71c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208ba71c"]])

export default __exports__